import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	copy: {
		id: 'backNavButton.copy',
		defaultMessage: 'Go Back',
		description: 'Link to go to the previous page',
	},
});
